import React from 'react';
import { EVIDENCE_META } from '@/lib/format2';

export function EvidenceBadge({ quality }) {
  const meta = EVIDENCE_META[quality] || EVIDENCE_META.Moderate;
  return (
    <span
      data-testid="evidence-quality-badge"
      className="inline-flex items-center gap-1.5 rounded-full text-[10px] px-2 py-0.5 uppercase tracking-wide font-medium border"
      style={{ color: meta.color, borderColor: `${meta.color}66`, background: `${meta.color}12` }}
      title={meta.hint}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: meta.color }} />
      Evidence: {quality}
    </span>
  );
}
